export default __webpack_public_path__ + "static/media/women-owned-000000.729118e9.png";